
export default {
  props: {
    show: { type: Boolean, default: false },
  },
}
